const riot = require('riot');

riot.tag2('page-campaigns-single-edit', '<div class="f"> <div class="h100vh sticky t0" data-is="module-sidebar"></div> <div class="w-full f fclm bg-pale_gray"> <div class="bg-white" data-is="module-page-header" title="{isNew ? &quot;キャンペーン新規作成&quot; : &quot;キャンペーン設定&quot;}" back="{true}" breadcrumbs="{breadcrumbs}"></div> <div class="p40"> <form if="{!isLoading}" onsubmit="{onSubmit}"> <div class="f fclm pt32 px32 pb16 rounded-8 bg-white elevation-default-low mb32"> <label class="block"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">キャンペーン名</div> <div class="ts-hxxs text-pink_70">必須 </div> </div> <input class="input w500" ref="name" type="text" required placeholder="キャンペーン名を入力" riot-value="{!isNew ? campaign.name : &quot;&quot;}" oninput="{changeData}"> </label> </div> <div class="f fclm rounded-8 bg-white overflow-hidden elevation-default-low"> <div class="section-padding"> <label class="block mb24"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">公開用会社名</div> <div class="ts-hxxs text-pink_70">必須 </div> </div> <input class="input w500" ref="display_company_name" type="text" required placeholder="公開用の会社名を入力" riot-value="{!isNew ? campaign.display_company_name : &quot;&quot;}" oninput="{changeData}"> </label> <label class="block mb24"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">公開用キャンペーン名</div> <div class="ts-hxxs text-pink_70">必須 </div> </div> <input class="input w500" ref="display_name" type="text" required placeholder="公開用のキャンペーン名を入力" riot-value="{!isNew ? campaign.display_name : &quot;&quot;}" oninput="{changeData}"> </label> <label class="block mb24"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">お問い合わせ先名</div> <div class="ts-hxxs text-pink_70">必須 </div> </div> <input class="input w500" ref="contact_name" type="text" required placeholder="お問い合わせ先名を入力" riot-value="{!isNew ? campaign.contact_name : &quot;&quot;}" oninput="{changeData}"> </label> <label class="block mb24"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">お問い合わせ先リンク</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <div class="ts-pxs text-gray_60 mb8">お問い合わせ先として表示するメールかURL、どちらかの入力が必須です。どちらも入力した場合には併記されます。<br><br>表示例）ご不明点などありましたら、( help@repro.io または https://repro.io/ )までお問い合わせ下さい。</div> <div class="mb8"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">お問い合わせ先メールアドレス</div> </div> <input class="input w500" ref="email" placeholder="メールアドレスを入力" riot-value="{!isNew ? campaign.contact_email : &quot;&quot;}" oninput="{changeData}" type="{\'email\'}"> </div> <div class="mb8"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">お問合せ先ホームページURL</div> </div> <input class="input w500" ref="site" type="url" placeholder="URLを入力" riot-value="{!isNew ? campaign.contact_site  : &quot;&quot;}" oninput="{changeData}"> </div> </label> <div> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">個人情報の取り扱いについて</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <div class="ts-pxs text-gray_60 mb8">ポイントを受け取るためには個人情報の取り扱いに同意してもらう必要があります。<br>御社で定められている個人情報の取り扱いやプライバシーポリシーに関する文章を入力するか、該当リンクを入力してください。<br>※現在配布するポイントサービスがPayPayのみの場合表示されませんが記載してください。<br><br>例）プライバシーポリシー<br>https://sample.com/privacy-policy.html</div> <textarea class="textarea w-full" placeholder="" rows="8" ref="terms" riot-value="{campaign?.terms}" required></textarea> </div> </div> <div class="bg-white" data-is="module-section-footer" buttons="{buttons}"></div> </div> </form> </div> </div> </div>', 'page-campaigns-single-edit,[data-is="page-campaigns-single-edit"]{display:block}', '', function(opts) {

    this.isLoading = true;
    this.limit = 50;
    this.buttons = [
      {
        type: 'submit',
        text: '保存',
        class: 'outline',
      },
    ];

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;

      if (!app.utils.permission.has('project_writer', { company_id: req.params.company_id, project_id: req.params.project_id})) {
        throw { status: 403 };
      }

      this.isLoading = true;
      this.update();
      var companyId = req.params.company_id;
      var projectId = req.params.project_id;
      var campaign_id = req.params.campaign_id;
      var isNew = campaign_id === 'new';

      if (!isNew) {
        var {campaign} = await app.api.child(`companies/${companyId}/projects/${projectId}/campaigns/${campaign_id}`).get();
      }

      this.isLoading = false;
      this.update();

      var breadcrumbs = [
        {
          link: `/app/companies/${companyId}/projects/${projectId}`,
          label: isNew ? "ダッシュボード": `${campaign.project.name} / ${campaign.name}`,
        },
      ];

      return {
        isNew,
        companyId,
        projectId,
        campaign,
        breadcrumbs,
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title(this.isNew ? 'キャンペーン作成' : 'キャンペーン設定', this),
      };
    };

    this.on('show', () => {
      this.isChange = false;
    });

    this.on('beforeunload', (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.onSubmit = async (e) => {
      e.preventDefault();

      if (!this.refs.email.value && !this.refs.site.value) {
        spat.modal.alert('問い合わせ先のメールアドレス\nもしくはホームページURLのどちらかを入力して下さい');
        return ;
      }

      var indicator = spat.modal.indicator();

      var query = {
        name: this.refs.name.value,
        display_name: this.refs.display_name.value,
        display_company_name: this.refs.display_company_name.value,
        contact_email: this.refs.email.value,
        contact_site: this.refs.site.value,
        contact_name: this.refs.contact_name.value,
        terms: this.refs.terms.value,
      };
      try {
        if (this.isNew) {
          var {campaign} = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/campaigns`).post(query);
          spat.modal.alert('作成しました');
        }
        else {
          var {campaign} = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}`).put(query);
          spat.modal.alert('更新しました');
        }
        spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${campaign.id}`);
        this.isChange = false;
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.backRoute = () => {
      if (this.isNew) {
        spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}`);
      }
      else {
        spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}`);
      }
    };

    this.onGoProjectSingle = (e) => {
      spat.router.push(`/app/companies/${this.company.id}/projects/${e.item.project.id}`);
    };

    this.changeData = () => {
      this.isChange = true;
    };
});